window.HindiGangaWebsiteConfig = {
  yearsExperience: "8+ Years",
  currencyRates: { inr: 1, usd: 95.24, eur: 111.80 },
  paymentApiBase: location.hostname === "localhost" ? "http://localhost:8000/api" : "https://hindiganga-api.onrender.com/api",
  offer: {
    original: 5000,
    price: 3000,
    title: "Special Admission Offer",
    description: "Save ₹2,000 on personalised 1-to-1 online classes.",
    active: true,
    popupEnabled: true,
    popupFrequencyDays: 7,
    ctaText: "Enroll Now",
    applicableSubjects: ["Hindi", "English", "Maths", "Science", "Coding"]
  },
  social: { instagram: "", linkedin: "", facebook: "" },
  assistant: {
    enabled: true,
    welcome: "Hello! I’m the Hindi Ganga Assistant. Ask me about subjects, 1-to-1 classes, fees, enrollment, refunds, or timings.",
    fallback: "I’m not certain about that. Please contact Hindi Ganga directly for the most accurate answer."
  }
};
